import { writable } from 'svelte/store';
const hooksAreaLoadingStore = writable(false);
export default hooksAreaLoadingStore;
